import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { OrganizationRegistration } from '@model/employer';
import WithRender from './Welcome.html';

@WithRender
@Component({})
export default class Welcome extends Vue {

    @Prop()
    public orgData: OrganizationRegistration;

    public created() {
        window.scrollTo(0, 0);
    }

    public onContinue() {
        this.$emit('next', 8);
    }
}
